(function () {
  'use strict';

  function refreshAllSizeFieldsets() {
    document.querySelectorAll('fieldset[data-is-size="true"]').forEach(refreshSizeFieldset);
  }

  function refreshSizeFieldset(fieldset) {
    var wrapper = fieldset.closest('.variant-wrapper');
    if (!wrapper) return;

    var form = fieldset.closest('form') || document;

    var variantsScript =
      wrapper.querySelector('[data-product-variants-json]') ||
      form.querySelector('[data-product-variants-json]');

    var variants = [];
    if (variantsScript) {
      try {
        variants = JSON.parse(variantsScript.textContent);
      } catch (err) {
        variants = [];
      }
    }

    var allFieldsets = Array.prototype.slice.call(
      form.querySelectorAll('fieldset[data-index^="option"]')
    );

    var selected = {};
    allFieldsets.forEach(function (fs) {
      var checked = fs.querySelector('[data-variant-input]:checked');
      if (checked) selected[fs.dataset.index] = checked.value;
    });

    function findMatchingVariant(candidateValues) {
      return variants.filter(function (v) {
        return allFieldsets.every(function (fs) {
          var key = fs.dataset.index; // "option1", "option2"...
          var wanted = candidateValues[key];
          if (wanted === undefined) return true;
          return v[key] === wanted;
        });
      })[0];
    }

    // ---- Stock badges ----
    if (variants.length) {
      fieldset.querySelectorAll('.variant-input--size').forEach(function (row) {
        var radio = row.querySelector('[data-variant-input]');
        var stockEl = row.querySelector('[data-stock]');
        var label = row.querySelector('.variant__button-label--circle');
        if (!radio || !stockEl) return;

        var candidate = {};
        for (var key in selected) candidate[key] = selected[key];
        candidate[fieldset.dataset.index] = radio.value;

        var variant = findMatchingVariant(candidate);

        stockEl.textContent = '';
        if (label) label.classList.remove('disabled');
        radio.disabled = false;

        if (!variant) return;

        if (!variant.available) {
          stockEl.textContent = 'Sold out';
          if (label) label.classList.add('disabled');
          radio.disabled = true;
        } else if (
          variant.inventory_management &&
          typeof variant.inventory_quantity === 'number' &&
          variant.inventory_quantity > 0 &&
          variant.inventory_quantity <= 10
        ) {
          stockEl.textContent = variant.inventory_quantity + ' left';
        }
      });
    }

    // ---- Garment measurement line ----
    var measurementsBox = wrapper.querySelector('[data-size-measurements]');
    if (!measurementsBox) return;

    var checkedSize = fieldset.querySelector('[data-variant-input]:checked');
    var chest = checkedSize && checkedSize.dataset.chest;

    if (!checkedSize || !chest) {
      measurementsBox.hidden = true;
      return;
    }

    measurementsBox.hidden = false;
    var chestEl = measurementsBox.querySelector('[data-measure="chest"]');
    var waistEl = measurementsBox.querySelector('[data-measure="waist"]');
    var hipEl = measurementsBox.querySelector('[data-measure="hip"]');

    if (chestEl) chestEl.textContent = checkedSize.dataset.chest;
    if (waistEl) waistEl.textContent = checkedSize.dataset.waist;
    if (hipEl) hipEl.textContent = checkedSize.dataset.hip;
  }

  document.addEventListener('click', function (e) {
    // Fallback: some themes intercept the click on the <label> and set
    // `checked` via JS without letting the native click bubble/fire a
    // real 'change' event. Catching label clicks too covers that case.
    var sizeLabel = e.target.closest && e.target.closest('.variant__button-label--circle');
    if (sizeLabel) {
      window.setTimeout(refreshAllSizeFieldsets, 0);
    }
  });

  function init() {
    refreshAllSizeFieldsets();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function () {
    refreshAllSizeFieldsets();
  });

  // Quick Shop injects its content well after page load, with no
  // dedicated event to hook into. Rather than watching the entire page
  // (expensive — fires on every DOM change anywhere, e.g. lazy images,
  // animations, cart drawer), we only watch the quick shop modal shells
  // themselves. They already exist in the DOM at load (empty, one per
  // product), so this is a small, fixed set of tiny subtrees to watch.
  function observeQuickShopModals() {
    var modals = document.querySelectorAll('.modal--quick-shop');

    modals.forEach(function (modal) {
      if (modal.dataset.sizeVariantObserved === 'true') return;
      modal.dataset.sizeVariantObserved = 'true';

      var scheduled = false;

      function scheduleRefresh() {
        if (scheduled) return;
        scheduled = true;

        // A few staggered passes catch the theme's own JS finishing its
        // default-variant selection shortly after content is injected
        // (it sets `checked` via a JS property, which MutationObserver
        // can't see directly — only the surrounding DOM insertion).
        refreshAllSizeFieldsets();
        window.setTimeout(refreshAllSizeFieldsets, 150);
        window.setTimeout(function () {
          refreshAllSizeFieldsets();
          scheduled = false;
        }, 500);
      }

      var observer = new MutationObserver(function (mutations) {
        var relevant = mutations.some(function (m) {
          return m.addedNodes && m.addedNodes.length > 0;
        });
        if (relevant) scheduleRefresh();
      });

      observer.observe(modal, { childList: true, subtree: true });
    });
  }

  document.addEventListener('DOMContentLoaded', observeQuickShopModals);
})();